<template>
  <div>
    <e-dialog
      :dialog-title="'商品预览'"
      :center-dialog-visible="dialogVisible"
      :popup-width="'90%'"
      :destroy-close="true"
      :modal-append-to-body="false"
      :show-btn="false"
      show-close-btn
      dialog-full-screen
      @updateVisible="closePreview"
      @resetPopupData="closePreview"
      @submitPopupData="closePreview"
    >
      <div style="height: 100%">
        <product-detail-floor1
          :product-detail="productDetail"
          :company-info="companyInfo"
        ></product-detail-floor1>
        <product-detail-floor2
          :product-detail="productDetail"
          :product-id="$route.query.productId"
        ></product-detail-floor2>
        <product-detail-floor3
          :product-detail="productDetail"
        ></product-detail-floor3>
      </div>
    </e-dialog>
  </div>
</template>

<script>
import EDialog from '@/modules/projectA/components/common/e-dialog';
import api from '@/modules/projectA/api/product/index';
import { Message } from 'element-ui';
import ProductDetailFloor1 from './product-detail-floor-1';
import ProductDetailFloor2 from './product-detail-floor-2';
import ProductDetailFloor3 from './product-detail-floor-3';

export default {
  components: {
    ProductDetailFloor1,
    ProductDetailFloor2,
    ProductDetailFloor3,
    EDialog,
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    productAuditId: {
      type: Number,
      default: 0,
    },
    skuId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      productDetail: {
        attrArray: [],
        dataList: [],
        userInfo: '',
      },
      companyInfo: {},
    };
  },
  watch: {
    dialogVisible(newVal) {
      if (newVal) {
        this.productAuditId && this.getAuditProductDetail();
        this.skuId && this.getMaintainProductDetail();
      }
    },
  },
  methods: {
    closePreview() {
      this.$emit('update:dialogVisible', false);
    },
    // 获取productId;
    getProductId(params) {
      const index = params.indexOf('.');
      return params.substring(0, index);
    },

    // 商品审核详情  外层是属性，内层是规格
    async getAuditProductDetail() {
      const { queryReleaseProductInfoById } = api;
      try {
        this.productDetailIng = true;
        const result = await queryReleaseProductInfoById({
          productAuditId: this.productAuditId,
        });
        console.log(result, 'resultresult');
        if (result.code === '200') {
          this.productDetail = {
            ...result.data.productVO,
            ...result.data.productVO,
            ...result.data.productVO.skus[0],
          };

          this.getSupplierInfo();
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getMaintainProductDetail() {
      const { querySkuInfoForEdite } = api;
      try {
        this.productDetailIng = true;
        const res = await querySkuInfoForEdite({ skuId: this.skuId });
        this.productDetailIng = false;
        if (res.code === '200') {
          const data = res.data?.skus[0];
          this.productDetail = { ...data };
          this.getSupplierInfo();
        } else {
          Message.closeAll();
          this.productDetail = {};
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getSupplierInfo() {
      const params = {
        searchtext: this.productDetail.supplierCompanyId,
        pageNum: 1,
        pageSize: 10,
      };
      const res = await api.querySupplier(params);
      if (res.data) {
        this.companyInfo = res.data;
        this.companyInfo.gradeId = parseFloat(this.companyInfo.gradeId);
        this.companyInfo.innovationEvaluate = parseFloat(
          this.companyInfo.innovationEvaluate
        );
      }
    },
  },
};
</script>
<style lang="scss">
.el-dialog.is-fullscreen {
  .el-dialog__body {
    max-height: none;
    display: flex;
    flex-flow: column;
    height: calc(100vh - 120px);
  }
}
</style>
